import { Media } from "@gogive/types";
import useSWR from "swr";
import { fetcher } from "../client";
import { mediaRoutes } from "./media.route";
import type { MediaListResponse } from "./media.mutation";

export const useMedia = (mediaId: number | null) => {
  const { data, error, mutate } = useSWR<Media>(
    mediaId ? [mediaRoutes.get(mediaId), {}] : null,
    fetcher
  );

  return {
    data,
    isLoading: !error && !data,
    isError: error,
    refresh: mutate,
  };
};

export const useMediaList = (params?: {
  page?: number;
  limit?: number;
  accountId?: string;
}) => {
  const page = params?.page ?? 0;
  const limit = params?.limit ?? 50;
  const accountId = params?.accountId;
  const swrParams: Record<string, string | number> = { page, limit };
  if (accountId) swrParams.accountId = accountId;

  const { data, error, mutate, isLoading } = useSWR<MediaListResponse>(
    [mediaRoutes.list, swrParams],
    fetcher
  );

  return {
    data,
    rows: data?.rows ?? [],
    total: data?.total ?? 0,
    page: data?.page ?? page,
    pages: data?.pages ?? 0,
    isLoading,
    isError: error,
    refresh: mutate,
  };
};
